import React, { useState } from 'react'
import SecondHeader from '../components/SecondHeader/SecondHeader'
import Footer from '../components/Footer/Footer'
import SampleBanner from '../components/sampleComponents/sampleBanner/SampleBanner'
import { useDispatch, useSelector } from 'react-redux'
import { forgotPasswordAPI } from '../redux/slices/ForgotPasswordSlice'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { forgotEmailSchema } from '../schemas/forgotEmailShema'

const ForgorPassword = () => {

    const [fogotPasswordEmail, setFogotpasswordEmail] = useState('');
    const loading = useSelector(state => state.forgotPasswordSlice.loading);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleForgotPassword = async (values) => {
        const res = await dispatch(forgotPasswordAPI(values));
        if (res?.payload?.status === 200) {
            navigate('/email-varification');
            localStorage.setItem("forgotEmailAddress", values.email);
        } else {
            setFogotpasswordEmail("")
        }
    }

    // Formik configuration
    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: forgotEmailSchema,
        onSubmit: (values) => {
            handleForgotPassword(values)
        }
    });

    return (
        <>
            <SecondHeader />
            <SampleBanner />
            <div className="signup-form xl-pt-5 xl-pb-5 lg-pt-5 lg-pb-5 md-pt-5 md-pb-5">
                <div className="container">
                    <div className="row justify-content-center mb-4">
                        <div className="col-xl-4 col-lg-4 col-md-8">
                            <h1 className="main-form-heading">Enter Your Email</h1>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-xl-4 col-lg-4 col-md-8 auth-form-card">
                            <form className="needs-validation" onSubmit={formik.handleSubmit}>
                                <div className="mb-3 custom-input-box">
                                    <input
                                        type="email"
                                        value={formik.values.email}
                                        name="email"
                                        // onChange={(e) => setFogotpasswordEmail(e.target.value)}
                                        onChange={formik.handleChange}
                                        className={`form-control ${formik.errors.email && formik.touched.email ? "input-error" : ""}`}
                                        placeholder="Enter Your Email"
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.errors.email && formik.touched.email && <p className="danger-text">{formik.errors.email}</p>}
                                </div>

                                <div className="submit-btn-form">
                                    <button type="submit" disabled={loading} className="btn btn-primary w-50">
                                        {!loading ? 'Submit Your Email' : <i style={{ fontSize: '22px' }} className="fa-solid fa-spinner fa-spin"></i>}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default ForgorPassword